import styled from "styled-components";

export const Logo = styled.div`
  height: 32px;
  background: rgba(255, 255, 255, 0.5);
  margin: 16px;
  text-align: center;
  font-size: 21px;
  font-weight: 600;
  color: #001529;
`;
